<template>
  <div class="row py-5 py-md-7" id="transactions">
    <div class="col-12 offset-md-3 col-md-8 animate anim-el">
      <div class="image-bg py-7" id="transaction-callout">
        <h3 class="gold-text">A Proven Track Record</h3>
        <h4 class="subhead white-text mb-5">
          Explore Our Representative Transactions
        </h4>
        <router-link :to="{ name: 'Transactions' }" class="btn -hollow_white"
          >View Transactions</router-link
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#transaction-callout {
  background-image: url(../assets/transaction-callout.jpg);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
</style>
